module.exports = __webpack_public_path__ + "static/media/veradero-6.bf8c81fe.jpg";